import React  from 'react'


export default class ButtonFooterContainer extends React.Component 
{
    render()
    {
        return (
            <div className='buttonfooter'>
                <div className="container-fluid">
                    <div className="row">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

